import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=00ad70b1&scoped=true&"
var script = {}
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=00ad70b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad70b1",
  null
  
)

export default component.exports